interface PageSeoConfig {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
}

interface SeoConfig {
  [lang: string]: {
    home: PageSeoConfig;
    faq: PageSeoConfig;
  };
}

const uzLatnKeywords =
  "lotin alifbosi, kirill alifbosi, yangi alifbo, yangi o‘zbek alifbosi, imlo, lugat, translit, лотин, лотин алифбоси, имло, кирилл алифбоси, узбек тили, ozbek tili, krill lotin online, lotinchadan kirilchaga, latin to kiril, latin to cyrillic, latin uzbek cyrillic converter, транслитератор узбекского языка. латиница - кириллица - латиница. ўзбек тили лотин - кирил, lotin - kiril - lotin alifbosi transliteratsiyasi";

const uzLatnHome: PageSeoConfig = {
  title: "O‘zbek kirill lotin translit va yangi alifbo (ş, ç, ö, ğ) konvertori — Lotin.uz",
  description:
    "O‘zbek kirill yozuvidan lotinga va aksincha o‘girish hamda matnni yangi o‘zbek alifbosiga (ş, ç, ö, ğ) o‘tkazish xizmati.",
  keywords: uzLatnKeywords,
  ogTitle: "O‘zbek kirill lotin translit va yangi alifbo (ş, ç, ö, ğ) konvertori — Lotin.uz",
  ogDescription:
    "O‘zbek kirill yozuvidan lotinga va aksincha o‘girish hamda matnni yangi o‘zbek alifbosiga (ş, ç, ö, ğ) o‘tkazish xizmati.",
  ogImage: "https://lotin.uz/img/og_cover.png",
};

const uzLatnFaq: PageSeoConfig = {
  title:
    "Tez-tez so'raladigan savollar: kirill-lotin translit va yangi alifbo (ş, ç, ö, ğ) — Lotin.uz",
  description:
    "Lotin.uz haqida savol-javoblar: o‘zbek kirill-lotin translit, yangi o‘zbek alifbosi (ş, ç, ö, ğ) va matnni yangi alifboga o‘girish.",
  keywords: uzLatnKeywords,
  ogTitle:
    "Tez-tez so'raladigan savollar: kirill-lotin translit va yangi alifbo (ş, ç, ö, ğ) — Lotin.uz",
  ogDescription:
    "Lotin.uz haqida savol-javoblar: o‘zbek kirill-lotin translit, yangi o‘zbek alifbosi (ş, ç, ö, ğ) va matnni yangi alifboga o‘girish.",
  ogImage: "https://lotin.uz/img/og_cover.png",
};

const seoConfig: SeoConfig = {
  default: { home: uzLatnHome, faq: uzLatnFaq },
  oz: { home: uzLatnHome, faq: uzLatnFaq },
  uz: {
    home: {
      title: "Ўзбек кирилл лотин транслит ва янги алифбо (ş, ç, ö, ğ) конвертори — Lotin.uz",
      description:
        "Ўзбек кирилл ёзувидан лотинга ва аксинча ўгириш ҳамда матнни янги ўзбек алифбосига (ş, ç, ö, ğ) ўтказиш хизмати.",
      keywords:
        "лотин алифбоси, имло, кирилл алифбоси, янги алифбо, узбек тили, транслитератор, лотин, лотин алифбоси, имло, кирилл алифбоси, узбек тили, ozbek tili, krill lotin online, lotinchadan kirilchaga, latin to kiril, latin to cyrillic, latin uzbek cyrillic converter, транслитератор узбекского языка. латиница - кириллица - латиница. ўзбек тили лотин - кирил, lotin - kiril - lotin alifbosi transliteratsiyasi",
      ogTitle: "Ўзбек кирилл лотин транслит ва янги алифбо (ş, ç, ö, ğ) конвертори — Lotin.uz",
      ogDescription:
        "Ўзбек кирилл ёзувидан лотинга ва аксинча ўгириш ҳамда матнни янги ўзбек алифбосига (ş, ç, ö, ğ) ўтказиш хизмати.",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
    faq: {
      title:
        "Тез-тез сўраладиган саволлар: кирилл-лотин транслит ва янги алифбо (ş, ç, ö, ğ) — Lotin.uz",
      description:
        "Lotin.uz ҳақида савол-жавоблар: ўзбек кирилл-лотин транслит, янги ўзбек алифбоси (ş, ç, ö, ğ) ва матнни янги алифбога ўгириш.",
      keywords:
        "лотин алифбоси, кирилл алифбоси, янги алифбо, транслит, лотин, лотин алифбоси, имло, кирилл алифбоси, узбек тили, ozbek tili, krill lotin online, lotinchadan kirilchaga, latin to kiril, latin to cyrillic, latin uzbek cyrillic converter, транслитератор узбекского языка. латиница - кириллица - латиница. ўзбек тили лотин - кирил, lotin - kiril - lotin alifbosi transliteratsiyasi",
      ogTitle:
        "Тез-тез сўраладиган саволлар: кирилл-лотин транслит ва янги алифбо (ş, ç, ö, ğ) — Lotin.uz",
      ogDescription:
        "Lotin.uz ҳақида савол-жавоблар: ўзбек кирилл-лотин транслит, янги ўзбек алифбоси (ş, ç, ö, ğ) ва матнни янги алифбога ўгириш.",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
  },
  ru: {
    home: {
      title:
        "Транслитератор кириллица-латиница и конвертер нового узбекского алфавита (ş, ç, ö, ğ) — Lotin.uz",
      description:
        "Онлайн-транслитерация узбекских текстов с кириллицы на латиницу и обратно, а также перевод на новый узбекский алфавит (ş, ç, ö, ğ).",
      keywords:
        "транслитератор узбекского языка, латиница кириллица, новый узбекский алфавит, узбек тили лотин кирил, лотин, лотин алифбоси, имло, кирилл алифбоси, узбек тили, ozbek tili, krill lotin online, lotinchadan kirilchaga, latin to kiril, latin to cyrillic, latin uzbek cyrillic converter, транслитератор узбекского языка. латиница - кириллица - латиница. ўзбек тили лотин - кирил, lotin - kiril - lotin alifbosi transliteratsiyasi",
      ogTitle:
        "Транслитератор кириллица-латиница и конвертер нового узбекского алфавита (ş, ç, ö, ğ) — Lotin.uz",
      ogDescription:
        "Онлайн-транслитерация узбекских текстов с кириллицы на латиницу и обратно, а также перевод на новый узбекский алфавит (ş, ç, ö, ğ).",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
    faq: {
      title:
        "Частые вопросы: транслитерация кириллица-латиница и новый узбекский алфавит (ş, ç, ö, ğ) — Lotin.uz",
      description:
        "Ответы на частые вопросы о Lotin.uz: транслитерация узбекского текста с кириллицы на латиницу и обратно, новый узбекский алфавит (ş, ç, ö, ğ) и перевод текста на него.",
      keywords:
        "транслитератор, кириллица латиница, новый узбекский алфавит, FAQ, лотин, лотин алифбоси, имло, кирилл алифбоси, узбек тили, ozbek tili, krill lotin online, lotinchadan kirilchaga, latin to kiril, latin to cyrillic, latin uzbek cyrillic converter, транслитератор узбекского языка. латиница - кириллица - латиница. ўзбек тили лотин - кирил, lotin - kiril - lotin alifbosi transliteratsiyasi",
      ogTitle:
        "Частые вопросы: транслитерация кириллица-латиница и новый узбекский алфавит (ş, ç, ö, ğ) — Lotin.uz",
      ogDescription:
        "Ответы на частые вопросы о Lotin.uz: транслитерация узбекского текста с кириллицы на латиницу и обратно, новый узбекский алфавит (ş, ç, ö, ğ) и перевод текста на него.",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
  },
  en: {
    home: {
      title:
        "Uzbek Cyrillic-Latin transliteration and new Uzbek alphabet (ş, ç, ö, ğ) converter — Lotin.uz",
      description:
        "Online transliteration of Uzbek text from Cyrillic to Latin and back, and conversion to the new Uzbek alphabet (ş, ç, ö, ğ).",
      keywords:
        "uzbek transliteration, uzbek cyrillic to latin, uzbek latin to cyrillic, new uzbek alphabet, uzbek alphabet converter, latin uzbek cyrillic converter, lotin, kirill, translit",
      ogTitle:
        "Uzbek Cyrillic-Latin transliteration and new Uzbek alphabet (ş, ç, ö, ğ) converter — Lotin.uz",
      ogDescription:
        "Online transliteration of Uzbek text from Cyrillic to Latin and back, and conversion to the new Uzbek alphabet (ş, ç, ö, ğ).",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
    faq: {
      title:
        "FAQ: Uzbek Cyrillic-Latin transliteration and the new Uzbek alphabet (ş, ç, ö, ğ) — Lotin.uz",
      description:
        "Answers to common questions about Lotin.uz: Uzbek Cyrillic-Latin transliteration, the new Uzbek alphabet (ş, ç, ö, ğ) and converting text to it.",
      keywords:
        "uzbek transliteration FAQ, new uzbek alphabet, uzbek cyrillic to latin, uzbek alphabet converter, latin uzbek cyrillic converter",
      ogTitle:
        "FAQ: Uzbek Cyrillic-Latin transliteration and the new Uzbek alphabet (ş, ç, ö, ğ) — Lotin.uz",
      ogDescription:
        "Answers to common questions about Lotin.uz: Uzbek Cyrillic-Latin transliteration, the new Uzbek alphabet (ş, ç, ö, ğ) and converting text to it.",
      ogImage: "https://lotin.uz/img/og_cover.png",
    },
  },
};

export function getSeoMeta(
  lang: string,
  page: "home" | "faq" = "home",
  currentUrl?: string
) {
  const pageConfig = seoConfig[lang]?.[page] || seoConfig.default[page];

  return {
    title: pageConfig.title,
    description: pageConfig.description,
    keywords: pageConfig.keywords,
    canonical: currentUrl || "https://lotin.uz",
    "og:type": "website",
    "og:url": currentUrl || "https://lotin.uz/",
    "og:title": pageConfig.ogTitle,
    "og:description": pageConfig.ogDescription,
    "og:image": pageConfig.ogImage,
    "twitter:card": "summary_large_image",
    "twitter:url": currentUrl || "https://lotin.uz/",
    "twitter:title": pageConfig.ogTitle,
    "twitter:description": pageConfig.ogDescription,
    "twitter:image": pageConfig.ogImage,
  };
}

const HREFLANG_PATHS: Record<string, string> = {
  "uz-Latn": "",
  "uz-Cyrl": "/uz",
  ru: "/ru",
  en: "/en",
};

// Path each page has after the language prefix, so alternates point at the
// same page in the other languages instead of their home pages.
const PAGE_PATHS: Record<"home" | "faq", string> = {
  home: "",
  faq: "/faq",
};

export function generateHreflangLinks(
  canonicalUrl: string,
  page: "home" | "faq" = "home"
) {
  let baseUrl = "https://lotin.uz";
  try {
    const parsed = new URL(canonicalUrl || "https://lotin.uz");
    baseUrl = parsed.origin;
  } catch {
    baseUrl = "https://lotin.uz";
  }

  const normalizedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;

  const pagePath = PAGE_PATHS[page];
  // The Uzbek Latin home page has no path at all; link it as "/"
  const url = (path: string) => `${normalizedBase}${path || "/"}`;

  // Lowercase `hreflang` on purpose: React's `hrefLang` is rendered verbatim,
  // and SEO checks such as `grep hreflang` miss the camel-cased attribute.
  const links = Object.entries(HREFLANG_PATHS).map(([hreflang, path]) => ({
    rel: "alternate" as const,
    hreflang,
    href: url(`${path}${pagePath}`),
  }));

  // Uzbek Latin (no language prefix) is the default version
  return [
    ...links,
    { rel: "alternate" as const, hreflang: "x-default", href: url(pagePath) },
  ];
}

export function getOgLocale(lang: string) {
  const map: Record<string, string> = {
    default: "uz_UZ", // Default language (Uzbek Latin)
    oz: "uz_UZ", // Uzbek Latin
    uz: "uz_UZ", // Uzbek Cyrillic
    ru: "ru_RU", // Russian
    en: "en_US", // English
  };
  return map[lang] || "uz_UZ";
}

export function buildHead(
  lang: "default" | "oz" | "uz" | "ru" | "en",
  page: "home" | "faq",
  canonicalUrl: string,
  currentPath: string
) {
  const meta = getSeoMeta(lang, page, canonicalUrl);
  const hreflangs = generateHreflangLinks(canonicalUrl || currentPath, page);
  const ogLocale = getOgLocale(lang);
  const ogLocaleAlternates = ["default", "oz", "uz", "ru", "en"]
    .filter((l) => l !== lang)
    .map((l) => ({ property: "og:locale:alternate", content: getOgLocale(l) }));

  const csrfToken = import.meta.env.VITE_CSRF_TOKEN;

  return {
    title: meta.title,
    meta: [
      ...(csrfToken ? [{ name: "csrf-token", content: csrfToken }] : []),
      { name: "robots", content: "index,follow" },
      { name: "title", content: meta.title },
      { name: "description", content: meta.description },
      { name: "keywords", content: meta.keywords },

      // Open Graph / Facebook
      { property: "og:type", content: meta["og:type"] },
      { property: "og:url", content: meta["og:url"] },
      { property: "og:title", content: meta["og:title"] },
      { property: "og:description", content: meta["og:description"] },
      { property: "og:image", content: meta["og:image"] },
      { property: "og:locale", content: ogLocale },
      ...ogLocaleAlternates,

      // Twitter
      { property: "twitter:card", content: meta["twitter:card"] },
      { property: "twitter:url", content: meta["twitter:url"] },
      { property: "twitter:title", content: meta["twitter:title"] },
      { property: "twitter:description", content: meta["twitter:description"] },
      { property: "twitter:image", content: meta["twitter:image"] },

      // Additional meta tags
      { name: "msapplication-TileColor", content: "#ffffff" },
      { name: "theme-color", content: "#ffffff" },
    ],
    links: [{ rel: "canonical", href: meta.canonical }, ...hreflangs],
  };
}

// Function to check if current path should be noindex
export function shouldNoIndex(pathname: string): boolean {
  const noIndexPaths = ["/auth", "/admin", "/backend", "/profile"];
  return noIndexPaths.some((path) => pathname.startsWith(path));
}

// Function to build complete head with all meta tags
export function buildCompleteHead(
  lang: "default" | "oz" | "uz" | "ru" | "en",
  page: "home" | "faq",
  canonicalUrl: string,
  currentPath: string,
  pathname: string
) {
  const baseHead = buildHead(lang, page, canonicalUrl, currentPath);

  // Add noindex meta if needed
  if (shouldNoIndex(pathname)) {
    baseHead.meta.unshift({ name: "robots", content: "noindex" });
  }

  return baseHead;
}
